export const fonts = {
    KapraNeue: {
        /**
         * Used as section title.
         *
         * Used as secondary section title.
         *
         * Used as primary card/sub-section title across the site.
         *
         * Used as secondary card/sub-section title across the site.
         */
        regular: 'KapraNeue-Regular',
        /**
         * Used as page title, usually in the hero.
         */
        demiBold: 'KapraNeue-DemiBold',
    },
    AvenirNext: {
        /**
         * This is our standard body text style across the site.
         *
         * Use this as a sub-text/caption, footnote etc.
         */
        regular: 'AvenirNext-Regular',
        /**
         * This is the smallest heading across the site.
         *
         * Use this style for the labels on the forms, badges, etc.
         *
         * Use Title Case for all Button and CTA links.
         *
         * Use all caps on small links. It shouldn’t be more than 3 words.
         */
        demiBold: 'AvenirNext-DemiBold',
    },
    Lora: {
        /**
         * Use this as standard style for blockquotes.
         */
        regular: 'Lora-Regular',
    },
};
